// extracted by mini-css-extract-plugin
export default {"root":"Signup_root__Li6Ri","form":"Signup_form__UHquO","phone":"Signup_phone__kItDT"};